import React, {
  createContext,
  FC,
  ReactNode,
  useContext,
  useMemo,
} from 'react';
import templates from './templates.json';
import {
  GetCommissionsTemplateResponseType,
  transformCommissionsTemplateResponse,
} from '../../endpoints/GetCommissionsTemplates';

type CommissionsProviderType = {
  templateData: GetCommissionsTemplateResponseType;
};

export const CommissionsProviderContext = createContext<
  CommissionsProviderType | undefined
>(undefined);

export const useCommissionsContext = () => {
  // https://stackoverflow.com/a/69735347
  const commissionsProviderContext = useContext(CommissionsProviderContext);
  if (!commissionsProviderContext)
    throw new Error(
      'No CommissionsProviderContext.Provider found when calling useCommissionsContext.'
    );
  return commissionsProviderContext;
};

export const CommissionsProvider: FC<{
  children: (ctx: CommissionsProviderType) => ReactNode;
}> = ({ children }) => {
  // Will connect to BE in GET-407
  const templateData = transformCommissionsTemplateResponse(templates);
  const providerValues = useMemo(
    () => ({
      templateData,
    }),
    [templateData]
  );

  return (
    <CommissionsProviderContext.Provider value={providerValues}>
      {children(providerValues)}
    </CommissionsProviderContext.Provider>
  );
};
